import { SmsType } from '@/services/SMS/interfaces';
import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export default class AddSmsTemplate {
  public name: string;
  public smsType: SmsType;
  public senderName:string;
  public message:string;

  public availableServices: string[] = ['SYSTEM','CUSTOM']

  public rules: { [key: string]: FormValidationFunction[] } = {
    name: [
      (v: string) => !!v || 'Template Name is required',
      (v: string) => v.length > 2 || 'Template Name should be at least 3 characters long',
    ],
    smsType: [
      (v: string) => this.availableServices.includes(v) || 'Invalid service provided',
    ],
    senderName: [
      (v: string) => !!v || 'Please select sender name',
    ],
    message: [
      (v: string) => !!v || 'Please enter a message',
    ],
  }
}

